import React from "react";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "../../data/content";

export default function WhatsAppFloat() {
  return (
    <a
      href={`https://wa.me/91${CONTACT.whatsapp}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="group fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_12px_40px_rgb(37,211,102,0.45)] transition-transform duration-200 hover:scale-105"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 blur-md transition-opacity group-hover:opacity-80" aria-hidden="true" />
      <MessageCircle size={26} className="relative" />
    </a>
  );
}
